module.exports = __webpack_public_path__ + "static/media/angle-left.0bb488f4.svg";